export const kAppConstants = {
	appStage: process.env.REACT_APP_STAGE,
	mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN,
	stripeCustomerPortalUrl: process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL_URL,
};
